import VuexPersistence from 'vuex-persist'
import { createLogger, GetterTree, ActionTree, MutationTree } from 'vuex'

// modules
import uiModule from './modules/ui/index'
import tasksModule from './modules/tasks/index'
import stockModule from './modules/stock/index'
import notificationsModule from './modules/notifications/index'
import Cleaner from '~/interfaces/Cleaner'

const debug = process.env.NODE_ENV !== 'production'

export const state = () => ({
  auth: {
    loggedIn: false,
    user: null as (Cleaner | null)
  }
})

export type RootState = ReturnType<typeof state>

export const getters: GetterTree<RootState, RootState> = {
  user: (state: RootState) => state.auth.user,
  loggedIn: (state: RootState) => state.auth.loggedIn
}

export const mutations: MutationTree<RootState> = {

}

export const actions: ActionTree<RootState, RootState> = {
  setUser({ commit }, payload) {
    commit('auth/SET', payload)
  },
  nuxtServerInit(/* { commit } */) {
    // eslint-disable-next-line no-console
    console.log('nuxtServerInit')
  }
}

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  modules: ['ui', 'tasks']
})

export default {
  /**
   * Assign the modules to the store.
   */
  modules: {
    ui: uiModule,
    tasks: tasksModule,
    notifications: notificationsModule,
    stock: stockModule
  },

  state,
  mutations,
  actions,
  getters,

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? [createLogger(), vuexLocal.plugin] : [vuexLocal.plugin]
}
